import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class WsUbigeoService {
  endpoint = `/api/WsUbigeo`;

  constructor(private http: HttpClient) { }

  paises(): Observable<any> {
    return this.http.get(`${this.endpoint}/paises`);
  }

  departamentos(IdPais: string): Observable<any> {
    return this.http.get(`${this.endpoint}/departamentos/${IdPais}`);
  }

  provincias(IdDep: any): Observable<any> {
    return this.http.get(`${this.endpoint}/provincias/${IdDep}`);
  }

  distritos(IdProv: any): Observable<any> {
    return this.http.get(`${this.endpoint}/distritos/${IdProv}`);
  }

}
